// Import dependencies
import React, { Component } from "react"
import ButtonBase from "@material-ui/core/ButtonBase"
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft"
import CloseIcon from "@material-ui/icons/Close"
// Import component
import { Button, Container, Text } from "../../../../components"
import { di } from "../../../../bottle"
import PropTypes from "prop-types"
import TweenMax from "gsap/TweenMaxBase"
import Transition from "react-transition-group/Transition"
import CircularProgress from "@material-ui/core/CircularProgress"
import { isEmpty } from "lodash"
// Keyboard
import Keyboard from "react-simple-keyboard"
import "react-simple-keyboard/build/css/index.css"
import english from "simple-keyboard-layouts/build/layouts/english";
import french from "simple-keyboard-layouts/build/layouts/french";
import german from "simple-keyboard-layouts/build/layouts/german";
import quebec from "../../../../assets/localization/quebecLayout";


// Component
export class FullSummary extends Component {
  static propTypes = {
    show: PropTypes.bool,
    onPressBackButton: PropTypes.func,
    onBikeChanged: PropTypes.func.isRequired,
  }

  static defaultProps = {
    show: false,
    onPressBackButton: () => undefined,
    onBikeChanged: () => undefined,
  }

  constructor(props) {
    // call base constructor
    super(props)
    this.hidePrice = di.profileManager.hidePrice()

    /** reference to keyboard dom element */
    this.keyboardRef = React.createRef()

    // initialize state
    this.state = {
      bike: di.garage.bike,
      name: "",
      nameError: undefined,
      email: "",
      emailError: undefined,
      phone: "",
      phoneError: undefined,
      checked: false,
      submitted: false,
      submitting: false,
      submitError: false,
      id: null,
      // keyboard state items
      layoutName: "default",
      input: "" // name, email, phone
    }
    switch (di.profileManager.lang) {
      case "de": 
        this.state.layout = german.layout
      break;
      case "fr":
        if (di.profileManager.region === "CA" || di.profileManager.region === "QC") {
          this.state.layout = quebec.layout;
        } else {
          this.state.layout = french.layout
        }
        break;
      default:
        this.state.layout = english.layout
    }

    this.setState = this.setState.bind(this)
    //disabled with email form on send to dealer
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
    this._onSubmit = this._onSubmit.bind(this)
  }

  componentWillMount() {
    this._garageSubscription = di.garage.bikeChanges$.subscribe(
      (bikeChanges) => {
        this.setState({
          bike: bikeChanges.bike,
          email: "",
          emailError: undefined,
          phone: "",
          phoneError: undefined,
        })
      }
    )
    //make a random 4 digit code that will be used for send to dealer quote
    const rString = this.randomString(4, "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ")
    this.setState({ id: rString })
  }

  componentWillUnmount() {
    // unregister the garage subscription
    if (this._garageSubscription) {
      this._garageSubscription.unsubscribe()
      this._garageSubscription = null
    }
  }

  onBackGroundPressed = (e) => {
    if (e.target !== this.background.div) return
    this.animator.reverse()
  }

  onBackPressed = () => {
    this.animator.reverse()
  }

  _displayPrice(part) {
    const modelSku = di.garage.bikeModel.sku
    let modelPrice = di.catalogManager.priceForPart(part.sku, modelSku)
    let price = ""
    if (modelPrice != undefined) {
      price = di.profileManager.localizePrice(modelPrice)
    } else {
      price = di.profileManager.localizePrice(
        di.catalogManager.priceForPart(part.sku)
      )
    }
    price = `${price} `
    return price
  }

  _onRemovePart = (part) => {
    // resolve inputs
    const { bike } = this.state

    // use remove part from bike (confirmation is handled by callback)
    if (bike.has(part)) {
      di.garage.removeBikeParts([part], this.props.onBikeChanged)
    }
  }

  randomString(length, chars) {
    let result = ""
    for (let i = length; i > 0; --i)
      result += chars[Math.floor(Math.random() * chars.length)]
    return result
  }

  async _onSubmit() {
    this.setState({
      submitting: true,
    })

    let total = ""

    if (!this.hidePrice) {
      total = di.garage.getTotalPrice()
    }
    console.log("[total]", total)
    let bikeType
    if (di.garage.bikeModel.id === "AR") {
      bikeType = "can-am ryker rotax Rally Edition"
    } else if (di.garage.bikeModel.id === "602") {
      bikeType = "can-am ryker rotax 600 ace"
    } else {
      bikeType = "can-am ryker rotax 900 ace"
    }

    const dataLayer = window.dataLayer || []

    try {
      //call submission manager to handle post request
      let status = await di.formSubmissionManager.submitLeadGeneration(
        JSON.stringify(this._exportBikeJson(this.state.bike))
      )
      console.log("submission status:", status)
      if (status) {
        dataLayer.push({
          event: "e_sendToDealer",
          model: bikeType,
          country: di.profileManager.region,
          language: di.localization.locale,
          price: total,
        })

        this.setState({
          submitted: true,
        })
      }
      this.setState({
        submitting: false,
      })
    } catch (e) {
      console.log("error", e)
      //handle error
      this.setState({
        submitting: false,
        submitted: false,
        submitError: true,
        //submitError: true
      })
    }
    return
  }

  // Keyboard Methods
  onChange = (input) => {
    this.setState({
      ...this.state,
      [this.state.input]: input
    })
    console.log("Input changed", input)
  }

  onKeyPress = (button) => {
    console.log("Button pressed", button)
    if (button === "{shift}" || button === "{lock}") this.handleShift()
  }

  handleShift = () => {
    let layoutName = this.state.layoutName

    this.setState({
      ...this.state,
      layoutName: layoutName === "default" ? "shift" : "default",
    })
  }

  onChangeInput = (inputName, input) => {
    this.setState({
      ...this.state,
      input: inputName,
    }, () => {
      this.keyboardRef.current.keyboard.setInput(input)
    })
  }

  // Methods for email submission on send to dealer - Disabled
  handleInputChanged = (value, stateKey) => {
    this.setState(
      (prev) => {
        const state = { ...prev }
        state[stateKey] = value
        return state
      },
      () => {
        const name = this.state.name
        const email = this.state.email
        const phone = this.state.phone
        this.validateFields(name, email, phone, false)
      }
    )
  }

  handleSubmit = () => {
    const name = this.state.name
    const email = this.state.email
    const phone = this.state.phone
    const valid = this.validateFields(name, email, phone)
    if (valid) {
      this._onSubmit()
    }
  }

  validateFields = (name, email, phone, setErrors = true) => {
    const validEmail = this.validateEmail(email)
    const validPhone = this.validatePhone(phone)
    // if everything is empty
    if (
      (name === undefined || isEmpty(name)) &&
      (email === undefined || isEmpty(email)) &&
      (phone === undefined || isEmpty(phone))
    ) {
      this.setState({
        ...this.state,
        nameError: false,
        emailError: false,
        phoneError: false,
      })
      return true
    }
    // if someone typed in their name they need to add a valid email or phone number
    if (
      name !== undefined &&
      !isEmpty(name) &&
      (email === undefined || isEmpty(email)) &&
      (phone === undefined || isEmpty(phone))
    ) {
      if (setErrors) {
        this.setState({ ...this.state, emailError: true, phoneError: true })
      }
      return false
    }
    // if someone typed in a phone or email they need to add a name
    if (
      (email !== undefined && !isEmpty(email)) ||
      (phone !== undefined && isEmpty(phone))
    ) {
      if (name === undefined || isEmpty(name)) {
        if (setErrors) {
          this.setState({ ...this.state, nameError: true })
        }
        if (!validEmail && setErrors) {
          this.setState({ ...this.state, emailError: !validEmail })
        }
        if (!validPhone && setErrors) {
          this.setState({ ...this.state, phoneError: !validPhone })
        }
        return false
      }
    }
    if (validEmail && validPhone) {
      this.setState({
        ...this.state,
        nameError: false,
        emailError: false,
        phoneError: false,
      })
      return true
    } else {
      if (!validEmail && setErrors) {
        this.setState({ ...this.state, emailError: !validEmail })
      }
      if (!validPhone && setErrors) {
        this.setState({ ...this.state, phoneError: !validPhone })
      }
      return false
    }
  }

  validateEmail(email) {
    //console.log("Email - ", email);
    //valid email
    let r1 =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    //empty string
    let r2 = /^$/

    return (
      r1.test(String(email).toLowerCase()) ||
      r2.test(String(email).toLowerCase())
    )
  }

  validatePhone(phoneNumber) {
    //console.log("phoneNumber - ", phoneNumber);
    //valid phoneNumber
    let r1 = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
    //empty string
    let r2 = /^$/

    return (
      r1.test(String(phoneNumber).toLowerCase()) ||
      r2.test(String(phoneNumber).toLowerCase())
    )
  }

  handleCheckboxChange() {
    this.setState({ checked: !this.state.checked })
  }

  _exportBikeJson(bike) {
    //create empty bike summary
    let bikeSummaryJson = {
      ID: null,
      Model: null,
      Engine: null,
      Parts: [],
      baseTotal: null,
      Total: null,
      Customer: {
        Name: null,
        Email: null,
        Phone: null,
      },
    }

    //add parts to summary
    bike._parts.forEach((part) => {
      let price = ""
      if (!this.hidePrice) {
        price = this._displayPrice(part)
      }
      let bikePart = {
        name: part.name,
        sku: part.sku,
        price: price,
      }

      if (part.subcategoryId === "Engine") {
        bikeSummaryJson.Engine = { name: bikePart.name, sku: bikePart.sku }
      } else if (part.subcategoryId === "Model") {
        bikeSummaryJson.Model = { name: bikePart.name, sku: bikePart.sku }
      } else {
        bikeSummaryJson.Parts.push(bikePart)
      }
    })

    let bikeSKU = `${bike.model.sku}.${bike.engine.sku}`

    if (bikeSKU == "STD.602") {
      bikeSummaryJson.Model.sku = "000F1KA00"
    } else if (bikeSKU == "STD.903") {
      bikeSummaryJson.Model.sku = "000F2KA00"
    } else if (bikeSKU == "AR.903") {
      bikeSummaryJson.Model.sku = "000F3KA00"
    }

    //push bike parts onto bike summary
    if (!this.hidePrice) {
      const priceValue = di.garage.getTotalPrice()
      const basePrice = di.garage.modelEnginePrice()
      bikeSummaryJson.Total = di.profileManager.localizePrice(priceValue)
      bikeSummaryJson.baseTotal = di.profileManager.localizePrice(basePrice)
    } else {
      bikeSummaryJson.Total = ""
      bikeSummaryJson.baseTotal = ""
    }

    //dont include email if checkbox is not checked
    if (this.state.email) {
      bikeSummaryJson.Customer.Email = this.state.email
    }
    if (this.state.phone) {
      bikeSummaryJson.Customer.Phone = this.state.phone
    }
    if (this.state.name) {
      bikeSummaryJson.Customer.Name = this.state.name
    }

    bikeSummaryJson.ID = this.state.id

    console.log(JSON.stringify(bikeSummaryJson))

    return bikeSummaryJson
  }

  render() {
    // resolve inputs
    const { garage, localization } = di
    let bike
    let title = localization.get("sendToDealer.enter.title")
    let subTitle = localization.get("sendToDealer.enter.text")

    //change send to dealer text depending on outcome
    if (this.state.submitError) {
      title = localization.get("sendToDealer.error.title")
      subTitle = localization.get("sendToDealer.error.body")
    } else if (this.state.submitted) {
      title = localization.get("sendToDealer.confirmation.title")
      subTitle = localization.get("sendToDealer.confirmation.text")
    }

    if (!this.state.bike) {
      bike = garage.bike
    } else {
      bike = this.state.bike
    }

    // render Model and engine
    const base = (
      <Container
        key={"model"}
        style={styles.sectionItem}
        justify="space-between">
        <Text style={styles.sectionTitle}>
          {localization.get("build.summary.model")}
        </Text>
        <Container style={styles.sectionDivider} />
        <Container style={styles.sectionItem}>
          <Text style={styles.item} bold>
            {bike.model.name}
          </Text>
        </Container>
        <Container style={styles.sectionItem}>
          <Text style={styles.item} bold>
            {bike.engine.name}
          </Text>
        </Container>
      </Container>
    )

    // render cosmetic parts
    const colorParts = bike.parts.filter((part) => part.swatch)

    const colorItems = colorParts.map((p, index) => {
      var isStockPart = false

      const stockParts = bike._parts.find(
        (p) => p.subcategoryId === "Model"
      ).stock

      // check to see if color part is stock classic black panel
      stockParts.map((sp, index) => {
        if (p.id === sp.part) {
          isStockPart = true
        }
      })
      return (
        <Container
          key={`item_${index}`}
          flex
          style={styles.sectionItem}
          direction="row">
          <Container
            flex
            style={styles.sectionDetails}
            direction="row"
            justify="space-between"
            alignContent="space-between">
            <Text style={styles.item} bold>{`${p.name}${
              p.color ? ` (${p.color})` : null
            }`}</Text>

            {!this.hidePrice && (
              <Text style={styles.item}>{this._displayPrice(p)}</Text>
            )}
          </Container>
          {!isStockPart ? (
            <ButtonBase onClick={() => this._onRemovePart(p)}>
              <CloseIcon style={styles.closeIcon} />
            </ButtonBase>
          ) : (
            <Container>
              <CloseIcon style={styles.closeIconHidden} />
            </Container>
          )}
        </Container>
      )
    })

    const color =
      colorParts.length > 0 ? (
        <Container
          key={"color"}
          style={styles.sectionItem}
          justify="space-between">
          <Text style={styles.sectionTitle}>
            {localization.get("build.buttons.color")}
          </Text>
          <Container style={styles.sectionDivider} />
          {colorItems}
        </Container>
      ) : null

    // render accessories
    const accessoryParts = bike.parts.filter(
      (part) =>
        part.subcategoryId !== "Engine" &&
        part.subcategoryId !== "Model" &&
        !part.swatch
    )

    const baseParts = bike.baseParts

    const accessoryItems = accessoryParts.map((p, index) => {
      var isBasePart = false

      baseParts.map((bp, index) => {
        if (p.id === bp.id) {
          isBasePart = true
        }
      })

      return (
        <Container
          key={`item_${index}`}
          flex
          style={styles.sectionItem}
          direction="row">
          <Container
            flex
            style={styles.sectionDetails}
            direction="row"
            justify="space-between"
            alignContent="space-between">
            <Text style={styles.item} bold>{`${p.name}${
              p.color ? ` (${p.color})` : ""
            }`}</Text>
            {/* if p.color doesn't exist "null is showing up in the sumamry, this is a hack to fix the problem*/}
            {!this.hidePrice && (
              <Text style={styles.priceItem}>{this._displayPrice(p)}</Text>
            )}
          </Container>

          {!isBasePart ? (
            <ButtonBase onClick={() => this._onRemovePart(p)}>
              <CloseIcon style={styles.closeIcon} />
            </ButtonBase>
          ) : (
            <Container>
              <CloseIcon style={styles.closeIconHidden} />
            </Container>
          )}
        </Container>
      )
    })

    const accessories =
      accessoryParts.length > 0 ? (
        <Container
          key={"build"}
          style={styles.sectionItem}
          justify="space-between">
          <Text style={styles.sectionTitle}>
            {localization.get("build.buttons.build")}
          </Text>
          <Container style={styles.sectionDivider} />
          {accessoryItems}
        </Container>
      ) : null

    let localizedMonthly = ""
    let priceString = ""
    let currencyString = ""
    let rate = 0
    let terms = 0

    if (!this.hidePrice) {
      rate = di.profileManager.interestRate
      terms = di.profileManager.terms
      const priceValue = di.garage.getTotalPrice()
      const monthlyValue = di.garage.monthlyPrice({ rate, terms }, priceValue)
      const localizedPrice = di.profileManager.localizePrice(priceValue)
      localizedMonthly = di.profileManager.localizePrice(monthlyValue)
      priceString = localizedPrice
      currencyString = di.profileManager.currency
      rate = di.profileManager.localizedInterestRate
    }

    return (
      <Transition
        timeout={1}
        mountOnEnter
        unmountOnExit
        in={this.props.show}
        addEndListener={(node, done) => {
          const onComplete = () => {
            this.setState({
              visible: true,
              submitting: false,
              submitted: false,
              submitError: false,
            })
            const rString = this.randomString(
              4,
              "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
            )
            this.setState({ id: rString })
          }
          const onReverseComplete = () => {
            this.setState({
              visible: false,
            })
            this.props.onPressBackButton()
          }
          this.animator = TweenMax.from(node, 0.7, {
            autoAlpha: 0,
            y: "-=50",
            onComplete: onComplete,
            onReverseComplete: onReverseComplete,
          })
        }}>
        <Container
          ref={(ref) => (this.background = ref)}
          style={{ ...styles.background, display: "flex" }}
          onClick={this.onBackGroundPressed}
          direction="row"
          justify={"flex-start"}>
          <Container flex style={styles.container}>
            <Container flex style={styles.summary}>
              {/* Header */}
              <Container
                style={{ display: "flex" }}
                direction="row"
                justify="space-between"
                alignContent="space-between">
                <Text style={styles.headerTitle} bold uppercase>
                  {localization.get("build.summary.title")}
                </Text>
                <ButtonBase onClick={this.onBackPressed}>
                  <ChevronLeftIcon style={{ color: styles.buttonText.color }} />
                  <Text style={styles.buttonText} bold>
                    {localization.get("common.back").toUpperCase()}
                  </Text>
                </ButtonBase>
              </Container>
              <Container style={styles.headerDivider} />

              {/* Content */}
              <Container flex direction="row">
                <Container flex style={styles.column}>
                  {base}
                  {color}
                </Container>
                <Container flex style={styles.column}>
                  {accessories}
                </Container>
              </Container>
            </Container>

            {/* Total pricing*/}
            {!this.hidePrice && (
              <Container alignItems="center" style={styles.priceContainer}>
                <Container
                  style={{
                    ...styles.headerDivider,
                    marginTop: 15,
                    marginBottom: 10,
                  }}
                />
                <Container
                  flex
                  direction="row"
                  justify="space-between"
                  alignContent="space-between"
                  alignItems="center">
                  <Text style={styles.legal}>
                    {di.profileManager.isNA
                      ? di.localization.get("build.summary.legal")
                      : di.localization.get("build.summary.legalLite")}
                  </Text>
                  <Container
                    flex
                    direction="row"
                    justify="space-between"
                    alignContent="space-between"
                    alignItems="center">
                    {di.profileManager.isNA && (
                      <Container>
                        <Text style={styles.citation}>
                          {di.localization.get("build.summary.estimated")}
                        </Text>
                        <Container flex direction="row" alignItems="center">
                          <Container flex direction="row" alignItems="baseline">
                            <Text bold style={styles.totalPrice}>
                              {localizedMonthly}
                            </Text>
                            <Text bold style={styles.currency}>
                              {!(
                                di.profileManager.region == "DE" ||
                                di.profileManager.region == "FR"
                              )
                                ? currencyString
                                : ""}
                            </Text>
                          </Container>
                          <Text style={styles.interest}>
                            {di.localization.get(
                              "build.summary.rateDescription",
                              rate,
                              terms
                            )}
                          </Text>
                        </Container>
                      </Container>
                    )}
                    {di.profileManager.isNA && (
                      <Container style={styles.verticalDivider} />
                    )}
                    <Container>
                      <Text style={styles.citation}>
                        {di.localization.get("build.summary.totalMSRP")}
                      </Text>
                      <Container flex direction="row" alignItems="center">
                        <Container flex direction="row" alignItems="baseline">
                          <Text bold style={styles.totalPrice}>
                            {priceString}
                          </Text>
                          <Text bold style={styles.currency}>
                            {!(
                              di.profileManager.region == "DE" ||
                              di.profileManager.region == "FR"
                            )
                              ? currencyString
                              : ""}
                          </Text>
                        </Container>
                      </Container>
                    </Container>
                  </Container>
                </Container>
              </Container>
            )}
          </Container>

          <Container style={styles.sendContainer} flex alignContent={"center"}>
            <Container flex direction={"column"} justify={"space-between"}>
              <Container>
                <Container flex direction={"row"} justify={"center"}>
                  <img
                    src={require("./assets/send-to-dealer-icon.png")}
                    style={styles.mailIcon}
                  />
                </Container>
                <Container>
                  <Container>
                    <Text style={styles.sendTitle}>{title}</Text>
                  </Container>
                  <Container>
                    <Text style={styles.sendText}>{subTitle}</Text>
                  </Container>
                  <Container></Container>
                </Container>
              </Container>
              <Container direction={"column"} alignSelf={"flex-start"}>
                {this.state.submitting ? (
                  <Container
                    flex
                    direction={"row"}
                    justify={"center"}
                    alignSelf={"flex-start"}>
                    <CircularProgress style={styles.progressCircle} />
                  </Container>
                ) : this.state.submitError ? (
                  <Container />
                ) : this.state.submitted ? (
                  <Container style={styles.confirmationContainer}>
                    <Text style={styles.sendText}>
                      {localization.get("sendToDealer.confirmation.label")}
                    </Text>
                    <Container flex direction={"row"} justify={"center"}>
                      <Text style={styles.confirmationID}>{this.state.id}</Text>
                    </Container>
                    <Text style={styles.sendText}>
                      {localization.get("sendToDealer.confirmation.cta")}
                    </Text>
                  </Container>
                ) : (
                  <Container width={"100%"} height={"100%"}>
                    <Container>
                      <label style={styles.emailText}>
                        {localization.get(
                          "sendToDealer.enter.textFieldNameLabel"
                        )}
                      </label>
                      <input
                        type="text"
                        id={"nameInput"}
                        style={
                          this.state.nameError
                            ? styles.formError
                            : styles.formInput
                        }
                        value={this.state.name}
                        onChange={(e) =>
                          this.handleInputChanged(e.target.value, "name")
                        }
                        onSelect={(e) => { this.onChangeInput("name", e.target.value) }}
                      />
                      {this.state.nameError ? (
                        <Text style={styles.errorMessage}>
                          {localization.get("sendToDealer.enter.errorName")}
                        </Text>
                      ) : (
                        <Text style={styles.errorMessage}></Text>
                      )}
                    </Container>
                    <Container>
                      <label style={styles.emailText}>
                        {localization.get(
                          "sendToDealer.enter.textFieldEmailLabel"
                        )}
                      </label>
                      <input
                        type="text"
                        id={"emailInput"}
                        style={
                          this.state.emailError
                            ? styles.formError
                            : styles.formInput
                        }
                        value={this.state.email}
                        onChange={(e) =>
                          this.handleInputChanged(e.target.value, "email")
                        }
                        onSelect={(e) => { this.onChangeInput("email", e.target.value) }}
                      />
                      {this.state.emailError ? (
                        <Text style={styles.errorMessage}>
                          {localization.get("sendToDealer.enter.errorEmail")}
                        </Text>
                      ) : (
                        <Text style={styles.errorMessage}></Text>
                      )}
                    </Container>
                    <Container>
                      <label style={styles.emailText}>
                        {localization.get(
                          "sendToDealer.enter.textFieldPhoneLabel"
                        )}
                      </label>
                      <input
                        type="text"
                        id={"phoneInput"}
                        style={
                          this.state.phoneError
                            ? styles.formError
                            : styles.formInput
                        }
                        value={this.state.phone}
                        onChange={(e) =>
                          this.handleInputChanged(e.target.value, "phone")
                        }
                        onSelect={(e) => { this.onChangeInput("phone", e.target.value) }}
                      />
                      {this.state.phoneError ? (
                        <Text style={styles.errorMessage}>
                          {localization.get("sendToDealer.enter.errorPhone")}
                        </Text>
                      ) : (
                        <Text style={styles.errorMessage}></Text>
                      )}
                    </Container>
                    <Container>
                      <Container
                        flex
                        direction={"row"}
                        alignContent={"flex-start"}>
                        {/* <Checkbox
                                                                iconStyle={{fill: 'white'}}
                                                                style={styles.checkbox}
                                                                onChange={this.handleCheckboxChange}
                                                            /> */}
                        {/* <Text style={styles.checkboxText}>
                                                                {localization.get("sendToDealer.enter.legal")}
                                                            </Text> */}
                      </Container>
                    </Container>
                    <Container>
                      <Button onClick={this.handleSubmit} style={styles.button}>
                        <Text style={styles.buttonText} bold uppercase>
                          {localization.get("sendToDealer.enter.button")}
                        </Text>
                      </Button>
                    </Container>
                  </Container>
                )}
              </Container>
            </Container>
          </Container>
          <Container style={keyboardStyle.container}>
            <Keyboard
              ref={this.keyboardRef}
              // keyboardRef={(r) => (this.keyboard = r)}
              theme={"hg-theme-default myTheme1"}
              layoutName={this.state.layoutName}
              layout={this.state.layout}
              mergeDisplay={true}
              display={{
                '{bksp}': '⌫',
                '{enter}': '↵',
                '{shift}': '⇧',
                '{tab}': '↹',
                '{lock}': '⇪',
              }}
              onChange={(input) => this.onChange(input)}
              onKeyPress={(button) => this.onKeyPress(button)}
            />
          </Container>
        </Container>
      </Transition>
    )
  }
}

const keyboardStyle = {
  container: {
    position: "fixed",
    width: "50%",
    height: "25%",
    backgroundColor: "transparent",
    bottom: 0,
    right: 0
  },
  keyboard: {
    width: "50%",
    height: "25%",
    position: "fixed",
    bottom: 0,
    right: 0
  }
}
// styles
const styles = {
  testContainer: {
    border: "solid 1px #fff",
  },
  confirmationContainer: {
    marginTop: 10,
  },
  background: {
    position: "fixed",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    paddingTop: 90 + 25, // height of the header + extra padding
    paddingLeft: 25,
    backgroundColor: "transparent",
  },
  mailIcon: {
    height: 50,
    Width: 80,
    marginBottom: 10,
  },
  sendTitle: {
    fontSize: 28,
    color: "#fff",
    fontFamily: "TradeGothicLTStd",
    fontWeight: "bold",
    marginBottom: 10,
  },
  confirmationID: {
    fontSize: 32,
    color: "#fff",
    fontFamily: "TradeGothicLTStd",
    fontWeight: "bold",
    marginBottom: 10,
  },
  container: {
    paddingTop: 15,
    paddingBottom: 15,
    width: 991,
    maxWidth: 991,
    height: 600,
    backgroundColor: "black",
  },
  sendContainer: {
    paddingLeft: 25,
    paddingRight: 25,
    paddingTop: 30,
    paddingBottom: 20,
    width: 400,
    maxWidth: 400,
    height: 490,
    backgroundColor: "black",
    marginLeft: 10,
  },
  headerTitle: {
    color: "white",
    fontSize: 22,
  },
  headerDivider: {
    marginTop: 5,
    width: "100%",
    height: 1,
    backgroundColor: "#ffd200",
  },
  column: {
    paddingRight: 40,
  },
  summary: {
    paddingLeft: 15,
    paddingRight: 15,
    overflow: "scroll",
  },
  sectionTitle: {
    marginTop: 8,
    marginBottom: 2,
    color: "#9b9b9b",
  },
  sectionDivider: {
    height: 1,
    backgroundColor: "#3f3f3f",
    width: 308,
  },
  sectionItem: {
    marginTop: 12,
    marginRight: 10,
    alignItems: "flex-start",
  },
  sectionDetails: {
    marginRight: 10,
  },
  item: {
    fontSize: 15,
    color: "#fff",
    paddingBottom: 10,
    textAlign: "flex-start",
  },
  priceItem: {
    fontSize: 15,
    color: "#fff",
    paddingBottom: 10,
    textAlign: "justify",
    paddingLeft: 15,
  },
  sendText: {
    fontSize: 12,
    color: "#fff",
    paddingBottom: 10,
    fontWeight: "bold",
    lineHeight: 1.33,
    fontFamily: "TradeGothicLTStd",
  },
  emailText: {
    fontSize: 12,
    color: "#fff",
    paddingBottom: 20,
  },
  closeIcon: {
    color: "#fff",
    fontSize: 19,
    lineHeight: 30,
  },
  closeIconHidden: {
    color: "#fff",
    fontSize: 19,
    lineHeight: 30,
    visibility: "hidden",
  },
  buttonText: {
    color: "#ffffff",
  },
  buttonContainer: {
    backgroundColor: "black",
    bottom: 0,
  },
  button: {
    width: 130,
    height: 42,
    margin: 0,
  },
  priceContainer: {
    padding: "0px 20px 0px 20px",
    bottom: 72,
  },
  verticalDivider: {
    height: 45,
    width: 2,
    backgroundColor: "#333333",
  },
  totalPrice: {
    display: "flex",
    alignItems: "center",
    color: "#ffffff",
    fontSize: 20,
    marginRight: 3,
  },
  currency: {
    display: "flex",
    alignItems: "center",
    color: "#ffffff",
    fontSize: 12,
  },
  interest: {
    width: 60,
    color: "#ffffff",
    fontSize: 12,
    marginLeft: 12,
  },
  legal: {
    width: "60%",
    padding: 10,
    paddingRight: 100,
    color: "#ffffff",
    fontSize: 12,
    marginBottom: 7,
  },
  legalFull: {
    width: "100%",
    padding: 10,
    paddingRight: 100,
    color: "#ffffff",
    fontSize: 12,
    marginBottom: 7,
  },
  citation: {
    color: "#ffffff",
    fontSize: 12,
    marginBottom: 7,
  },
  checkboxText: {
    fontSize: 12,
    color: "#fff",
    fontFamily: "TradeGothicLTStd",
    fontWeight: "bold",
    paddingTop: 18,
    paddingBottom: 20,
  },
  checkbox: {
    color: "white",
    paddingTop: 11,
  },
  progressCircle: {
    color: "white",
    marginTop: 40,
  },
  formError: {
    height: 30,
    backgroundColor: "#161616",
    borderWidth: 2,
    borderColor: "#ff0000",
    fontSize: 15,
    paddingVertical: 6,
    paddingLeft: 8,
    color: "#fff",
    width: "96%",
  },
  formInput: {
    height: 30,
    backgroundColor: "#161616",
    borderWidth: 2,
    borderColor: "#aaaaaa",
    fontSize: 15,
    paddingVertical: 6,
    paddingLeft: 8,
    color: "#fff",
    marginBottom: 17,
    width: "96%",
  },
  errorMessage: {
    fontSize: 12,
    color: "#ff0000",
    textAlign: "justify",
    // marginBottom: 15,
  },
}



// WEBPACK FOOTER //
// ./src/pages/Customization/components/FullSummary/index.js